// extracted by mini-css-extract-plugin
export default {"duyuruOutlet":"HaberOutlet_duyuruOutlet__171Z6","fade":"HaberOutlet_fade__wOOZ7","haberOutletHeader":"HaberOutlet_haberOutletHeader__UUljg"};